import { Input } from 'antd';
import { FC } from 'react';

import { IBaseInput } from '../type';

const BaseInput: FC<IBaseInput> = ({
  title,
  val,
  placeholder,
  handleChange,
  submitted = false,
  required,
}) => (
  <>
    <div className="content-plain-title">
      {required ? (
        <>
          <span className="content-plain-title-required">*</span>
          <span>{title}</span>
        </>
      ) : (
        title
      )}
    </div>
    <div className="content-input-box">
      <Input
        placeholder={placeholder}
        value={val}
        onChange={(event) => {
          handleChange(event.target.value);
        }}
        disabled={submitted}
      />
    </div>
  </>
);

export default BaseInput;
